function showLoadingSpinner() {
    const loadingSpinner = document.querySelector('#loading-spinner');
    if (loadingSpinner) loadingSpinner.classList.remove('hidden');
}

function hideLoadingSpinner() {
    const loadingSpinner = document.querySelector('#loading-spinner');
    if (loadingSpinner) loadingSpinner.classList.add('hidden');
}

export { showLoadingSpinner, hideLoadingSpinner };
